import parseJSON from './parse-json';
import ordered from './ordered';

const prettify = (id) => {
  var ugly = document.getElementById(id).value;
  var obj = parseJSON(ugly);
  if (!obj) {
    throw Error('Not parsed!');
  }

  obj = ordered(obj);

  if (Object.keys(obj).length === 0) {
    return false;
  }

  var pretty = JSON.stringify(obj, undefined, 2);
  document.getElementById(id).value = pretty;

  return true;
};

export default prettify;